import React from "react"
import Loading from "src/app/admin/loading"
import { Company } from "../types"
import { CompanyTableRow } from "./CompanyTableRow"

interface CompanyTableProps {
  companies: Company[]
  isLoading: boolean
  isError: boolean
}

export const CompanyTable: React.FC<CompanyTableProps> = ({ companies, isLoading, isError }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-fixed divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="w-[80px] px-4 py-3 text-center align-middle text-[1.6rem] font-medium uppercase tracking-wider text-gray-500">
              ID
            </th>
            <th className="w-[200px] px-4 py-3 text-left align-middle text-[1.6rem] font-medium uppercase tracking-wider text-gray-500">
              事業者名
            </th>
            <th className="w-[200px] px-4 py-3 text-left align-middle text-[1.6rem] font-medium uppercase tracking-wider text-gray-500">
              メールアドレス
            </th>
            <th className="w-[80px] px-4 py-3 text-center align-middle text-[1.6rem] font-medium uppercase tracking-wider text-gray-500">
              店舗数
            </th>
          </tr>
        </thead>
        {isLoading && <Loading />}
        {isError && (
          <div className="py-12 w-96">
            <div className="text-danger font-bold text-[1.6rem]">
              データの読み込みに失敗しました
            </div>
          </div>
        )}
        {!isLoading && !isError && companies.length > 0 && (
          <tbody className="divide-y divide-gray-200 bg-white">
            {companies.map((company) => (
              <CompanyTableRow key={company.id} company={company} />
            ))}
          </tbody>
        )}
      </table>
    </div>
  )
}
